export const PERSONA_DETAILS = {
  "sme-founder": {
    id: "sme-founder",
    firstName: "Daniel",
    img: "/personas/sme-founder.jpg",
    person: "Daniel Koh",
    role: "Founder & Managing Director",
    company: "NovaTech Precision Engineering Pte Ltd",
    tagline: "Win tenders & bank facilities without hiring an ESG team",
    profile: [
      ["Industry", "Precision metal components — aerospace & medtech supply chain"],
      ["Size", "42 employees · single SG plant"],
      ["Revenue", "S$12M"],
      ["Segment", "SME supplier to listed MNC buyers"],
    ],
    before: "Daniel lost a S$2M aerospace tender when the buyer's ESG questionnaire asked for Scope 1+2 emissions, an energy baseline and a sustainability policy he couldn't produce. Consultant quotes started at five figures — for a document, not a capability. He has no headcount to spare for ESG.",
    value: [
      { title: "Answer customer ESG questionnaires from live data", body: "AI import turns utility bills, fuel receipts and payroll exports into classified ESG records with Singapore emission factors — tender responses come from real numbers, not guesswork.", features: "AI Import · Core ESG Metrics · SEFR factors" },
      { title: "Become bankable and grant-ready", body: "Readiness scoring shows exactly what a lender needs; the grant engine matches EEG for equipment upgrades and EFS-Green for financing — with application packs generated from his own data.", features: "Green Financing · Grants · Readiness Prep" },
      { title: "No ESG hire required", body: "The Lite plan costs less per month than one consultant hour. Daniel's operations manager runs it alongside her day job — the AI does the classification, she does the review.", features: "Lite plan S$18/user · AI with human review" },
    ],
    metrics: [
      ["3", "tender questionnaires answered in month one"],
      ["S$30k", "EEG co-funding identified for chiller upgrade"],
      ["+0", "additional headcount needed"],
    ],
    career: "For an SME founder, sustainability is no longer compliance — it is market access. A verifiable ESG posture puts NovaTech on MNC approved-vendor lists its competitors can't reach, strengthens banking relationships, and builds the audit-ready data room that raises the company's value at succession or exit.",
  },
  "esg-manager": {
    id: "esg-manager",
    firstName: "Priya",
    img: "/personas/esg-manager.jpg",
    person: "Priya Nair",
    role: "Group ESG Manager",
    company: "Harborline Logistics Group",
    tagline: "One control tower instead of forty spreadsheets",
    profile: [
      ["Industry", "Regional 3PL logistics & warehousing"],
      ["Size", "850 employees · 6 sites across SG & MY"],
      ["Revenue", "S$320M"],
      ["Segment", "Mid-market group, large listed customers"],
    ],
    before: "Every reporting season Priya reconciled 40 spreadsheets holding three versions of the truth — chasing site managers by email for diesel litres, arguing about conversion factors, and rebuilding the same GRI tables by hand. Data collection consumed the time that analysis and strategy should have had.",
    value: [
      { title: "One governed data spine", body: "ERP, fleet and HR data flow through AI import with anomaly detection, duplicate flags and full lineage — one dataset that every framework draws from.", features: "AI Import · Anomalies · Data Lineage" },
      { title: "Map frameworks once, report many", body: "SGX Core Metrics, GRI, TCFD and CDP are generated from the same records. AI drafts the narrative; Priya reviews and signs off — weeks of writing become days.", features: "Frameworks Mapping · AI Drafting · Reports" },
      { title: "Defend targets with glide paths", body: "Targets, glide-path status chips and the net-zero roadmap give her an evidence-backed answer when the exec team asks 'are we on track?'", features: "Targets · Net Zero Roadmap · Scorecard" },
    ],
    metrics: [
      ["6 wks → 9 days", "reporting cycle"],
      ["99.9", "data quality score maintained"],
      ["40 → 0", "spreadsheets retired"],
    ],
    career: "ESG managers who operate governed data platforms stop being data janitors and become strategic advisors. Priya now briefs the board's sustainability committee directly — the visibility and platform fluency that make the Head of Sustainability promotion a matter of when, not if.",
  },
  "cfo": {
    id: "cfo",
    firstName: "Marcus",
    img: "/personas/cfo.jpg",
    person: "Marcus Lim",
    role: "Group Chief Financial Officer",
    company: "Vertex Hospitality Holdings",
    tagline: "Carbon as a managed cost — tax, ICP, grants, green loans",
    profile: [
      ["Industry", "Hotels, F&B and lifestyle venues"],
      ["Size", "2,400 employees · 14 properties"],
      ["Revenue", "S$780M"],
      ["Segment", "Large private group preparing for IPO"],
    ],
    before: "Carbon sat on Marcus's risk register as an unquantified line. Energy costs climbed, the carbon tax trajectory pointed at S$80/t, grant deadlines passed unnoticed, and green financing conversations stalled because the banks asked for evidence the group couldn't assemble.",
    value: [
      { title: "Put a price on carbon — statutory and shadow", body: "The Finance & Offset control tower projects Carbon Pricing Act liability to 2030 and runs an internal carbon price with escalation — carbon becomes a managed cost with an owner, not a surprise.", features: "Carbon Tax & CPA · ICP · Cost Projection" },
      { title: "Fund the transition with other people's money", body: "Grant matching (EDG, EEG, EFS-Green) with claims tracking, plus green loan and SLL matching with readiness scores and lender-ready packs — abatement CAPEX gets cheaper capital.", features: "Grants · Green Financing · Readiness Packs" },
      { title: "De-risk the IPO sustainability story", body: "Audit-grade lineage, immutable trails and IFRS S2-aligned disclosure mean the prospectus's sustainability section survives due diligence.", features: "Data Lineage · IFRS S2 · Assurance Packs" },
    ],
    metrics: [
      ["S$195k/yr", "shadow carbon cost made visible & owned"],
      ["S$500k", "green facility secured (illustrative)"],
      ["4", "grants matched with claims tracked"],
    ],
    career: "CFOs who quantify climate become the natural owners of the sustainability P&L. Marcus turned ESG from a cost centre into cheaper capital and an equity story — exactly the profile boards and investors now expect in a listed-company CFO.",
  },
  "board": {
    id: "board",
    firstName: "Amelia",
    img: "/personas/board.jpg",
    person: "Dr. Amelia Tan",
    role: "Independent Director · Chair, Sustainability Committee",
    company: "Pan-Asia Marine Ltd",
    tagline: "Decision-ready oversight, IFRS S2-aligned",
    profile: [
      ["Industry", "Marine & offshore engineering"],
      ["Size", "5,600 employees · yards in SG, ID, VN"],
      ["Revenue", "S$2.1B"],
      ["Segment", "SGX Mainboard-listed, global clients"],
    ],
    before: "Board packs arrived late, inconsistent between quarters and impossible to interrogate. With climate disclosure now a directors' duty, Amelia carried personal accountability for numbers she had no way to verify — and management's answer to 'how do we know?' was a shrug.",
    value: [
      { title: "Decision-ready, not data-heavy", body: "The board dashboard and ESG scorecard show performance against targets with off-track flags — the five minutes that matter, not fifty pages that don't.", features: "Board Dashboard · Scorecard · Off-track flags" },
      { title: "IFRS S2-aligned with evidence attached", body: "Disclosures map to ISSB requirements and every figure carries an assurance evidence trail — the committee approves with confidence, not hope.", features: "IFRS S1/S2 · Assurance Evidence · Audit Trail" },
      { title: "Stress-test strategy, not just report it", body: "Climate scenario analysis and financial-risk quantification turn the sustainability agenda into a strategy conversation the full board engages with.", features: "TCFD Scenarios · Financial Risk · Net Zero Roadmap" },
    ],
    metrics: [
      ["3 wks → 2 days", "board pack preparation"],
      ["100%", "KPIs with owners and time-bound targets"],
      ["2 clicks", "from any board figure to its source"],
    ],
    career: "Sustainability-fluent directors are the most sought-after profile in board renewals. Amelia's committee sets the governance standard other boards benchmark against — protecting her directorship, her reputation, and the company's licence to operate.",
  },
  "auditor": {
    id: "auditor",
    firstName: "Wei Jie",
    img: "/personas/auditor.jpg",
    person: "Ong Wei Jie",
    role: "Senior Manager, ESG Assurance",
    company: "Ascent Assurance LLP",
    tagline: "Every figure traceable to source in two clicks",
    profile: [
      ["Industry", "Audit & advisory"],
      ["Size", "300 professionals"],
      ["Clients", "50 to 5,000 employees, listed & private"],
      ["Segment", "Limited & reasonable assurance engagements"],
    ],
    before: "Wei Jie's fieldwork was archaeology: sampling from screenshots, spreadsheets with broken links, and factors nobody could source. Every evidence request took a week of client emails. Limited assurance on that foundation was a professional risk he carried personally.",
    value: [
      { title: "Two clicks to source", body: "Any figure drills down to the source document, formula, emission factor version, author and timestamp — sampling becomes verification, not excavation.", features: "Data Lineage · Evidence Files · Audit Log" },
      { title: "Governed factors and visible AI", body: "Emission factors are versioned with sign-off records, and the AI-use transparency log shows exactly where AI touched the numbers and who reviewed it.", features: "Factor Governance · AI Transparency Log" },
      { title: "Read-only access, immutable trail", body: "A dedicated auditor role gives direct platform access with immutable audit trails — no email attachments, no version roulette.", features: "Auditor Role · Immutable Trails · RBAC" },
    ],
    metrics: [
      ["Days → minutes", "evidence request turnaround"],
      ["100%", "sample traceability to source"],
      ["-40%", "fieldwork hours on data gathering (illustrative)"],
    ],
    career: "IFRS S2 is creating a wave of ESG assurance mandates, and the practices that master platform-based evidence will win them. Wei Jie is building his firm's ESG assurance methodology around data lineage — the specialism that makes partners.",
  },
};

export const PERSONA_ORDER = ["sme-founder", "esg-manager", "cfo", "board", "auditor"];
